import angular from 'angular';

import { RotatividadeIndexController } from './index/rotatividade.index.controller';

import { RotatividadeListRouting } from './rotatividade.routes';

import { RotatividadeService } from './rotatividade.service';

import { RotatividadeGridComponent } from './grid/rotatividade.grid.component';

export const RotatividadeModule = angular.module('RotatividadeModule', ['ui.router.state', ])
    .controller('RotatividadeIndexController', RotatividadeIndexController )
    .service('RotatividadeService', RotatividadeService)
    .component(RotatividadeGridComponent.selector, RotatividadeGridComponent)
    .config(RotatividadeListRouting)
    .name;
